import { render, staticRenderFns } from "./FormaPagamentoRoute.vue?vue&type=template&id=6da9a74a"
import script from "./FormaPagamentoRoute.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports